import { IColumn } from '../../types';
import { IGridColumnProps } from '../..';
import { StudentColumn } from './offerStudent';
import { UniversityNameColumn } from './universityName';
import { FeeStatusColumn } from './feeStatus';
import { NationalityColumn } from './nationality';
import { CourseColumn } from './course';
import { ModeColumn } from './mode';
import { StatusColumn } from './status';
import { AppliedDateColumn } from './appliedDate';
import { IssuedDateColumn } from './issuedDate';
import { SelectColumn } from './select';
import { RequirementsToAssessColumn } from './requirementsToAssess';
import { ApplicantLastUpdatedColumn } from './applicantLastUpdated';
import { DaysInStage } from './daysInStage';
import { EntryYearColumn } from './entryYear';
import { AgentColumn } from '../applicationColumns/agent';

/**
 * Some pages on the dashboard render "offer" columns but are capable of showing both applications and offers in their lists.
 * In these cases, we need to ensure that the columns we return can handle both applications and offers without breaking.
 * This function returns the full set of offer columns, which should be safe to use in these mixed contexts.
 */

export const getApplicantOfferColumns = (_input: IGridColumnProps): IColumn[] => [
  SelectColumn(),
  StudentColumn(),
  UniversityNameColumn(),
  FeeStatusColumn(),
  NationalityColumn(),
  RequirementsToAssessColumn(),
  ApplicantLastUpdatedColumn(),
  AgentColumn(),
  CourseColumn(),
  ModeColumn(),
  EntryYearColumn(),
  StatusColumn(),
  AppliedDateColumn(),
  IssuedDateColumn(),
  DaysInStage(),
];
